import React from "react";
import "./Turntable_Activity_details_rules.css";
import Common_white_header from "../../../Common/Common_Component/Common_white_header/Common_white_header";
import Rules_card from "../../../Common/Common_Component/Rules_card/Rules_card";

function Turntable_Activity_details_rules() {
  return (
    <>
      <section className="Vip_Rules Turntable_Activity_details_rules">

        {/* List of Rules Cards */}
        <div className="Rules_card">
          <div className="rules_section">
            <div className="heading_bg_holder">
              <div className="img_holder">
                <img
                  src="/assets/images/Invitation_Reward_Rules/heading_bg.png"
                  className="bg_img"
                  alt="bg"
                />
              </div>
              <div className="rules_title">
                <p>Rules</p>
              </div>
            </div>
            <p>
              Members must reach the single deposit amount and cumulative deposit amount to be eligible to participate in the lottery
            </p>

            <p>
              There are 6 subordinate levels in inviting friends. If A invites
              B, then B is a level 1 subordinate of A. If B invites C, then C
              is a level 1 subordinate of B and level 2 of A.
            </p>

            <p>
              There are 6 subordinate levels in inviting friends. If A invites
              B, then B is a level 1 subordinate of A. If B invites C, then C
              is a level 1 subordinate of B and level 2 of A.
            </p>

            <p>
              There are 6 subordinate levels in inviting friends. If A invites
              B, then B is a level 1 subordinate of A. If B invites C, then C
              is a level 1 subordinate of B and level 2 of A.
            </p>

            <div className="for_example_holder">
              <p>For example：</p>
              <p>
                If a member's single deposit exceeds <span>₹200,000.00</span>{" "}
                on the same day, he or she will receive <span>6</span> lucky
                draw opportunities. The lottery draws are valid for the same
                day and cannot be accumulated to the next day!
              </p>
            </div>
          </div>
        </div>

      </section>
    </>
  );
}

export default Turntable_Activity_details_rules;
